import $ from 'jquery';

$(() => {
  const productFormatSelect = $('.product-side-panel #format');
  $(productFormatSelect).on('change', (e) => {
    const selectedOptionDataValue = $(e.target).siblings('.selectize-control').find('.item').attr('data-value');

    if ((parseFloat(selectedOptionDataValue) === 57) || (parseFloat(selectedOptionDataValue) === 58)) { // eslint-disable-line max-len
      $('.product-side-panel #quantity')[0].selectize.disable();
    } else {
      $('.product-side-panel #quantity')[0].selectize.enable();
    }
  });
});



/** WEBPACK FOOTER **
 ** ./src/js/dropdown-disable.js
 **/